// extracted by mini-css-extract-plugin
export default {"container":"Shs2XIm17ByoLjcOrTFU9A==","title":"akF2bd8XRs6jTpYyccf9YQ==","description":"vOl2Mv36VPUbj1IvI+bnJQ=="};